/**
 * Component Accordion
 * 
 * @module component-accordion
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'component-accordion';

if (!customElements.get(customElements.component)) {
 
    class componentAccordion extends HTMLElement {
 
        /**
         * Accordion web component.
         * 
         * @constructor
         */
        constructor() {

            super();

            this.trigger   = this.querySelector('[data-accordion-trigger]');
            this.container = this.querySelector('[data-accordion-container]');
            this.isOpen    = false;

            this.initEvents();
        }
 
        /**
         * Init component events.
         * 
         * @returns {undefined}
         */
        initEvents() {

            if (!this.container || !this.trigger)
                return false;
        
            this.loadAttributes();

            this.trigger.addEventListener('click', event => {

                event.preventDefault();

                // TODO: Calc content height to apply an animation on toggle
                this.toggle(this.trigger).then((newContentHeight) => {
                    this.applyMaxHeightOnParent(newContentHeight);
                });
            });

            if (this.hasAttribute('data-active')) {

                this.toggle(this.trigger).then((newContentHeight) => {
                    this.applyMaxHeightOnParent(newContentHeight);
                });
            }
        }

        /**
          * Change the parent max-height
          * @param {integer} newContentHeight A data-accordion-container height
          * @return {undefined}
        */
        applyMaxHeightOnParent(newContentHeight) {

            if(this.isOpen){
                this.container.style.maxHeight = this.container.scrollHeight + newContentHeight + "px";
            }
            else {
                this.container.style.maxHeight = "0px";
            }
        }
 
        /**
         * Load accordion attributes
         * 
         * @return {undefined}
         */
        loadAttributes() {
 
            this.close();

            let id = Math.floor(Math.random() * 10000);

            this.trigger.setAttribute('aria-controls', 'accordion__container_' + id);
            this.trigger.id = 'accordion__trigger__' + id;

            this.container.setAttribute('role', 'region');
            this.container.setAttribute('aria-labelledby', 'accordion__trigger__' + id);
            this.container.id = 'accordion__container__' + id;
        }
 
        /**
         * Init Accordion toggle
         * 
         * @returns {Promise} Promise object represents a number.
         */
        toggle() {
 
            return new Promise((resolve, reject) => {

                if (this.container) {
                    
                    if (this.isOpen) {

                        this.close();

                    } else {

                        this.open();
                    }

                    resolve(this.container.scrollHeight);
                }
            });
        }
 
        /**
         * Close accordion
         * 
         * @return {undefined}
         */
        close() {

            icon_menu_right   = this.querySelector('[data-icon-menu-right]');
            icon_close = this.querySelector('[data-icon-close]');

            if (icon_menu_right) {
                icon_menu_right.classList.remove('hidden');
            }

            if (icon_close) {
                icon_close.classList.add('hidden');
            }
 
            this.trigger.classList.remove('active');
            this.container.classList.remove('active');
            this.container.setAttribute('aria-expanded', 'false');
            this.isOpen = false;

            setTimeout(() => {
              if(!this.container.classList.contains('active')) {
                this.container.classList.add('hidden');
              }
            }, 500);
        }
 
        /**
         * Open accordion
         * 
         * @return {undefined}
         */
        open() {
 
            icon_menu_right   = this.querySelector('[data-icon-menu-right]');
            icon_close = this.querySelector('[data-icon-close]');

            if (icon_menu_right) {
                icon_menu_right.classList.add('hidden');
            }

            if (icon_close) {
                icon_close.classList.remove('hidden');
            }

            this.trigger.classList.add('active');
            this.container.classList.add('active');
            this.container.classList.remove('hidden');
            this.container.setAttribute('aria-expanded', 'true');
            this.isOpen = true;
        }
    }
 
    customElements.define(customElements.component, componentAccordion);
}